import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_RuleTable = _resolveComponent("RuleTable")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "my-3 justify-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_menu, {
                        "open-on-hover": "",
                        "offset-y": "",
                        location: "bottom"
                      }, {
                        activator: _withCtx(({ props }) => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_btn_primary, _mergeProps({ key: 0 }, props, { block: "" }), {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode(" Ajouter ")
                                ])),
                                _: 2
                              }, 1040))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, { nav: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (
                                        _ctx.$router.push({
                                            name: 'new-export-office-sheet',
                                            params: { format: 'xlsx' },
                                        })
                                    ))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createTextVNode("$fa-chevron-right")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                      _createTextVNode("Export XLSX")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (
                                        _ctx.$router.push({
                                            name: 'new-export-office-sheet',
                                            params: { format: 'docx' },
                                        })
                                    ))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                      _createTextVNode("$fa-chevron-right")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                      _createTextVNode("Export DOCX")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "8",
                    class: "pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                        "append-inner-icon": "$search",
                        label: "Rechercher",
                        outlined: "",
                        "hide-details": "",
                        clearable: "",
                        "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = '')),
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_combobox, {
                        modelValue: _ctx.filterCompany,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterCompany) = $event)),
                        items: _ctx.allAvailableCompanies,
                        label: "Société",
                        "item-value": "value",
                        dense: "",
                        outlined: "",
                        "hide-details": "",
                        "item-title": (item) => item.key
                      }, null, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_RuleTable, {
            rule: 'exportOffice',
            items: _ctx.sortedItems,
            actionFunction: _ctx.getActions,
            hideDuplication: true,
            hideIntersection: true,
            accountingCompanyId: _ctx.accountingCompanyId,
            maxHeight: _ctx.maxHeightRT,
            onToRoute: _cache[5] || (_cache[5] = ($event: any) => (_ctx.routeExportsOfficeEdition($event.id))),
            onDelete: _cache[6] || (_cache[6] = ($event: any) => {
                    _ctx.patternToDelete = $event;
                    _ctx.deleteDialog = true;
                })
          }, null, 8, ["items", "actionFunction", "accountingCompanyId", "maxHeight"])
        ]),
        _: 1
      }),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.deleteDialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.deleteDialog) = $event)),
        title: "Supprimer",
        error: true,
        onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.patternToDelete = undefined)),
        onValid: _ctx.deletePattern,
        validLoading: _ctx.deleteLoading,
        width: "800px"
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer cette règle ?", -1)
        ])),
        _: 1
      }, 8, ["modelValue", "onValid", "validLoading"])
    ]),
    _: 1
  }))
}